import * as Styled from './DraggableAnswer.styles'

import { Box, IconButton, Stack } from '@mui/material'

import Input from '../../components/Input/Input'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'

type DraggableAnswerProps = {
  index: number
  control: any
  remove: (index?: number | number[] | undefined) => void
  provided: any
  snapshot: any
  formName: string
  field: any
  placeholder?: string
}

const DraggableAnswer = ({
  index,
  control,
  remove,
  provided,
  snapshot,
  formName,
  placeholder,
}: DraggableAnswerProps) => {
  return (
    <>
      <Styled.DraggableBox
        {...provided.draggableProps}
        ref={provided.innerRef}
        data-is-dragging={snapshot.isDragging}
      >
        <Box display="flex" sx={{ width: '100%' }}>
          <Stack
            direction={{ mobile: 'column', tablet: 'row', desktop: 'row' }}
            width="100%"
            sx={{ marginRight: 2 }}
          >
            <Input
              name={`${formName}[${index}].answer`}
              control={control}
              label="Answer"
              required
              fullWidth
              removeMarginTop
              placeholder={`${placeholder ?? ''}`}
            />
          </Stack>
          <Box sx={{ display: 'flex', alignItems: 'center', width: '80px' }}>
            <IconButton
              {...provided.dragHandleProps}
              onClick={(event) => {
                event.preventDefault()
                remove(index)
              }}
              color="primary"
              sx={{ height: '40px', width: '40px' }}
            >
              <UnfoldMoreIcon />
            </IconButton>
            <IconButton
              onClick={(event) => {
                event.preventDefault()
                remove(index)
              }}
              color="primary"
              sx={{ height: '40px', width: '40px' }}
            >
              <RemoveCircleOutlineIcon />
            </IconButton>
          </Box>
        </Box>
      </Styled.DraggableBox>
    </>
  )
}
export default DraggableAnswer
